import { render, staticRenderFns } from "./ChangeCustomerPhoneAlertModal.vue?vue&type=template&id=514e68c1&"
import script from "./ChangeCustomerPhoneAlertModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeCustomerPhoneAlertModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports